import type { Enum } from './enum.types';

export const CookieCategory = {
  ESSENTIAL: 1,
  PERFORMANCE: 2,
  TARGETING: 4,
} as const;
export type CookieCategory = Enum<typeof CookieCategory>;

declare global {
  interface Window {
    OptanonActive: boolean;
    Optanon: {
      OnConsentChanged: (callback: () => unknown) => unknown;
      AllowAll: () => unknown;
      ToggleInfoDisplay: () => unknown;
      TriggerGoogleAnalyticsEvent: (name: string, content: string) => unknown;
    };
    OptanonActiveGroups?: string;
  }
}
